import { ICommand, IQuery } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { StudentValueModel } from '../global/components/student_value/model/student_value_model';
import { RouterHelper } from '../global/helpers/router_helper';
import { APDegreeMapQuery } from '../plan/components/degree_map/queries/ap_degree_map_query';
import { LargeCourseGroupModel } from '../plan/components/large_course_group/models/large_course_group_model';
import { APTermsQuery } from '../plan/queries/ap_terms_query';
import { LoadCustomTextCommand } from './../custom_texts/commands/load_custom_text_command';
import { MySmartCatalogRoutes } from './ap_smart_catalog_routes';

export const largeCourseGroupCommonState: ng.ui.IState = {
  url: 'coursegroup/:termId/:slotId/',
  resolve: {
    query: (
      $stateParams: ng.ui.IStateParamsService,
      ngAPTermsQuery: APTermsQuery,
      ngAPDegreeMapQuery: APDegreeMapQuery
    ) => ($stateParams.termId > 0 ? ngAPTermsQuery : ngAPDegreeMapQuery)
  },
  data: {
    pageTitle: 'Planner course group list'
  },
  onEnter: (
    $state: ng.ui.IStateService,
    ngLargeCourseGroupModel: LargeCourseGroupModel,
    routerHelper: RouterHelper,
    $timeout: ng.ITimeoutService
  ) => {
    if (_4.isEmpty(ngLargeCourseGroupModel.read().selectedSlot)) {
      const redirectingState = '^.default';
      const TIME_TO_FIX_ANGULAR_STATE_ERROR = 10;
      $timeout(() => {
        if (routerHelper.isValidState(redirectingState)) {
          $state.go(redirectingState);
        }
      }, TIME_TO_FIX_ANGULAR_STATE_ERROR);
    } else {
      return;
    }
  }
};

export const planResolve = {
  studentNk: () => null,
  studentDetails: () => null,
  accountIdentity: (loadAccountCommand: ICommand) => loadAccountCommand(),
  customTexts: (loadCustomTextCommand: LoadCustomTextCommand) => loadCustomTextCommand(),
  gradesConfig: (loadGradeConfigsCommand: ICommand) => loadGradeConfigsCommand()
};

const myPlanView = {
  '': {
    template: `<ap-planner></ap-planner>`
  }
};
export const myPlanState: ng.ui.IState = <ng.ui.IState>{
  url: 'plan/',
  sticky: true,
  views: myPlanView,
  resolve: planResolve
};
export const myMultiPlanState: ng.ui.IState = <ng.ui.IState>{
  url: 'multiplan/',
  sticky: true,
  resolve: planResolve
};

export const APMultiPlanRoutes = {
  'my.planner.multiplan': {
    ...myMultiPlanState,
    resolve: {
      ...planResolve
    },
    views: {
      '': {
        template: ` <ap-multi-planner is-editable="true"></ap-multi-planner>
        <ui-view name='modal'></ui-view>`
      },
      'terms@my.planner.multiplan': {
        template: `<ap-planner-mm-terms is-editable="true"></ap-planner-mm-terms>`
      }
    }
  },
  'my.planner.multiplan.default': <ng.ui.IState>{
    url: 'default/',
    views: {
      'default@my.planner.multiplan': {
        template: `<ap-multi-planner-resources is-editable="true"></ap-multi-planner-resources>`
      }
    },
    data: {
      pageTitle: 'My Planner',
      academicPlanUrl: 'reg/academicplan',
      preventResetFocus: true
    },
    onEnter: () => {
      window.scrollBy(0, 1);
    } // HACK to force update of popper
  }
};

export const ApPlanRoutes = {
  'my.planner.plan': {
    ...myPlanState,
    resolve: {
      ...planResolve,
      flaggedCourses: (accountIdentity: any, loadCommentCommand: ICommand) => loadCommentCommand(`/coreuser/comment/`),
      externalRegistrationEnabled: (appConfigModel: any, FEATURE_SCHEDULER_NK: any) =>
        appConfigModel.isFeatureEnabled(FEATURE_SCHEDULER_NK),
      externalRegistrationUrl: (externalRegistrationEnabled: boolean, externalRegistrationLinkCommand: ICommand) =>
        externalRegistrationEnabled ? true : externalRegistrationLinkCommand(),
      allowToProceed: (preventAccessToPlannerCommand: ICommand, studentValue: any) => preventAccessToPlannerCommand()
    },
    views: {
      '': {
        template: `
                <ap-planner is-editable="true"></ap-planner>
                <ui-view name='modal'></ui-view>
                `
      },
      'terms@my.planner.plan': {
        template: `<ap-planner-terms is-editable="true"></ap-planner-terms>`
      }
    }
  },
  'my.planner.plan.default': <ng.ui.IState>{
    url: 'default/',
    views: {
      'default@my.planner.plan': {
        template: '<ap-planner-resources is-editable="true"></ap-planner-resources>'
      }
    },
    data: {
      pageTitle: 'My Planner',
      academicPlanUrl: 'reg/academicplan',
      preventResetFocus: true
    },
    onEnter: () => {
      window.scrollBy(0, 1);
    } // HACK to force update of popper
  },
  'my.planner.plan.coursegroup': <ng.ui.IState>{
    ...largeCourseGroupCommonState,
    views: {
      'largeCourseGroup@my.planner.plan': {
        template: '<large-course-group query="$resolve.query" is-editable="true"></large-course-group>'
      }
    }
  },
  ...MySmartCatalogRoutes
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_plan_routes.ts